import React, { useState } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import {
  Grid,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@material-ui/core";
import EditTwoToneIcon from "@material-ui/icons/EditTwoTone";
import Loader from "../Components/loader";

import { connect } from "react-redux";
import { useRef } from "react";

const useStyles = makeStyles((theme: Theme) =>
createStyles({
  root: {
    flexGrow: 1,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "155px",
    textTransform: "capitalize",
  },
  margin: {
    margin: theme.spacing(1),
  },
  table: {
    maxWidth: "100%",
    margin: "auto",
  },
  center: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  start: {
    display: "flex",
    justifyContent: "flex-start",
  },
  end: {
    display: "flex",
    justifyContent: "flex-end",
  },
  gap: {
    fontSize: "14px",
    margin: "0 -40px 0 40px",
  },
  select: {
    margin: "0 0 0 -8px",
    minWidth: "155px",
    width: "100%",
    height: "40px",
  },
  textFieldGap: {
    padding: "0 10px",
  },
  centerIt: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  startIt: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  checkBoxGap: {
    padding: "0 40px",
  },
  formContorlLabel: {
    padding: "0 0 0 25px",
    margin: "0 0 0 15px",
    color: "rgba(0, 0, 0, 0.54)",
  },
})
);

interface Props {
  setRateListUpdate: any;
  getRateList: any;
  rateList: any;
  loading: boolean;
}
const LabRateList: React.FC<Props> = ({
  getRateList,
  rateList,
  loading,
  setRateListUpdate,
}) => {
  const timer = useRef<any>(0);
  const classes = useStyles();
  const [center, setCenter] = useState<any>([]);
  const [centreId, setCentreId] = useState<any>([]);
  const [page, setPage] = useState(0);
  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    if (newPage > page) {
      let url = rateList.links && rateList.links.next.split("?")[1];
      getRateList(url);
    } else if (newPage < page) {
      let url = rateList.links && rateList.links.previous.split("?")[1];
      getRateList(url);
    }
    setPage(newPage as number);
  };
  return (
    <form className={classes.root} style={{ width: "100%", marginTop: 20 }}>
      <Grid container>
        <Grid item xs={12}>
          <Paper style={{ width: "100%" }}>
            <TableContainer style={{ height: "390px" }}>
              {loading ? (
                <Loader />
              ) : (
                <Table aria-label="simple table" stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">S. No.</TableCell>
                      <TableCell align="center">Lab Name</TableCell>
                      <TableCell align="center">Rate List Name</TableCell>
                      <TableCell align="center">Edit</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rateList.results &&
                      rateList.results.length > 0 &&
                      rateList.results.map((row: any, index: number) => {
                        return (
                          <TableRow key={index}>
                            <TableCell align="center">{index + 1}</TableCell>
                            <TableCell align="center">
                              {row.assigned_lab?.name}
                            </TableCell>
                            <TableCell align="center">{row.name}</TableCell>
                            <TableCell align="center">
                              <Button color="primary" variant="contained">
                                <EditTwoToneIcon
                                  onClick={() => setRateListUpdate(row)}
                                />
                              </Button>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              )}
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[]}
              colSpan={3}
              count={rateList.count}
              rowsPerPage={rateList.page_size}
              page={page}
              onPageChange={handleChangePage}
            />
          </Paper>
        </Grid>
      </Grid>
    </form>
  );
};

const mapStateToProps = (state: any) => ({
  loading: state.GenomicsAdminReducer.loading,
});

export default connect(mapStateToProps, {})(LabRateList);
